import Dinero from 'dinero.js';

Dinero.globalFormat = '$0,0.00';

export default Dinero;
